import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { createSelector } from 'reselect';
import lodash from 'lodash';
import { IPumpingStationFlowmeterSize } from '../../../../@types/model/masterData/pumpingStation/flowmeterSize';
import { IRootState } from '../../../../@types/redux';
import { connect } from 'react-redux';
import MasterDataPumpingStationFlowmeterSizeFunctions from '../../../../store/masterData/pumpingStation/flowmeterSize/functions';

interface IPumpingStationFlowMeterSizeSelectorProps {
    value : number | null;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : number | null) => void;

    isLoading : boolean;
    flowMeterSizes : Array<IPumpingStationFlowmeterSize>;
}

interface IPumpingStationFlowMeterSizeSelectorState { }

class PumpingStationFlowMeterSizeSelectorComponent extends React.PureComponent<IPumpingStationFlowMeterSizeSelectorProps, IPumpingStationFlowMeterSizeSelectorState> {
    constructor(props : IPumpingStationFlowMeterSizeSelectorProps) {
        super(props);

        this.state = {};
    }

    public componentDidMount() {
        MasterDataPumpingStationFlowmeterSizeFunctions.load();
    }

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : string;
    } | null | undefined) => {
        this.props.onChange(value?.value ? parseFloat(value.value) : null);
    };

    private readonly getData = (state : IPumpingStationFlowMeterSizeSelectorState, props : IPumpingStationFlowMeterSizeSelectorProps) => props.flowMeterSizes;
    private readonly getValue = (state : IPumpingStationFlowMeterSizeSelectorState, props : IPumpingStationFlowMeterSizeSelectorProps) => props.value;
    private readonly getRequired = (state : IPumpingStationFlowMeterSizeSelectorState, props : IPumpingStationFlowMeterSizeSelectorProps) => props.required;


    private readonly getFlowMeterSizes = createSelector([
        this.getData,
    ], (flowMeterSizes) => flowMeterSizes.filter(x => x.isActive).map(x => x.size).sort((a, b) => a - b));

    private readonly getFlowMeterSizesForDropdown = createSelector([ 
        this.getRequired, this.getFlowMeterSizes, 
    ], (required, flowMeterSizes) => {
        
        const dropdownData = lodash.map(flowMeterSizes, (element) => ({ label: `${element}`, value: element.toString() }));
        
        if (!required) {
            dropdownData.unshift({
                label: 'ALL',
                value: '',
            });
        }

        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([ 
        this.getValue, this.getRequired, this.getFlowMeterSizes, 
    ], (value, required, flowmeterSizes) => {
        if (value) {
            const flowmeterSize = flowmeterSizes.find(element => element === value);

            if (flowmeterSize) {
                return { label: flowmeterSize.toString(), value: flowmeterSize.toString() };
            } else {
                return { label: value.toString(), value: value.toString() };
            }
        }

        if (!value && !required) {
            return {
                label: 'ALL',
                value: '',
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, className, disabled } = this.props;

        const dropdownData = this.getFlowMeterSizesForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl margin={'normal'} fullWidth className={className} disabled={disabled} error={required && !value}>
                <Autocomplete 
                    id={'flowmeterSize'}
                    options={dropdownData}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth label={'Flowmeter Size'} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
            </FormControl>  
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return { 
        isLoading: state.masterData.pumpingStation.flowmeterSize.isLoading,
        flowMeterSizes: state.masterData.pumpingStation.flowmeterSize.flowmeterSizes,
    };
};

const PumpingStationFlowMeterSizeSelector = connect(
    mapStateToProps,
)(PumpingStationFlowMeterSizeSelectorComponent);

export default PumpingStationFlowMeterSizeSelector;